/** `sections/impact-report-partners.liquid` — `<impact-report-partners>`: a
 *  continuously scrolling logo ticker. Clones the logo group enough times to
 *  fill the viewport and drives the CSS animation via custom properties.
 */

class ImpactReportPartners extends HTMLElement {
  #abort
  #ticker
  #track
  #group

  connectedCallback() {
    this.#ticker = this.querySelector('[data-ticker]')
    this.#track = this.querySelector('[data-track]')
    this.#group = this.querySelector('[data-group]')

    if (!this.#ticker || !this.#track || !this.#group) return

    this.#abort = new AbortController()
    this.#setup()
    window.addEventListener('resize', this.#setup, { signal: this.#abort.signal })
  }

  disconnectedCallback() {
    this.#abort?.abort()
  }

  #setup = () => {
    this.#track.querySelectorAll('.impact-report-partners-group.is-clone').forEach((clone) => clone.remove())

    const groupWidth = this.#group.offsetWidth
    const tickerWidth = this.#ticker.offsetWidth

    if (!groupWidth || !tickerWidth) return

    let totalWidth = groupWidth
    while (totalWidth < tickerWidth + groupWidth) {
      const clone = this.#group.cloneNode(true)
      clone.classList.add('is-clone')
      this.#track.appendChild(clone)
      totalWidth += groupWidth
    }

    const pixelsPerSecond = 80
    const duration = groupWidth / pixelsPerSecond

    this.#track.style.setProperty('--ticker-distance', `${groupWidth}px`)
    this.#track.style.setProperty('--ticker-duration', `${duration}s`)
  }
}

if (!customElements.get('impact-report-partners')) {
  customElements.define('impact-report-partners', ImpactReportPartners)
}
